import React from "react";
import Section from "Section";
import COZY_RUHACKS from "./media/N11.png";

export default function Intro() {
  return (
    <Section bcolor="#0000" style={{ zIndex: 5 }}>
      <div className="intro">
        <div className="intro-text">
          <div className="intro-flex">
            <div className="intro-flex__left">
              <div className="text-yellow intro-title">RU Hacks 2022</div>
              <div className="intro-margin-bottom">Virtual Hackathon</div>{" "}
              <div className="intro-margin-bottom">May 6th - May 8th</div>
            </div>
            <div className="intro-flex__right">
              <img src={COZY_RUHACKS} alt="" className="intro-image" />
            </div>
          </div>
          <div className="intro-flex">
            <a href="https://app.ruhacks.com/">Hacker Applications</a>
            <a href="https://forms.gle/v95qZEoPBJw4ogoY6">
              Mentor / Workshop Host Applications
            </a>
          </div>
        </div>
      </div>
    </Section>
  );
}
